import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      align: "right"
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.form = {};
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v("新增")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Logo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-image", {
          attrs: {
            src: scope.row.logo,
            width: "60"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "link",
      label: "链接"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateDialog(scope.row);
            }
          }
        }, [_vm._v("修 改")])];
      }
    }])
  })], 1), _c("el-dialog", {
    attrs: {
      title: "".concat(_vm.$route.meta.title, "\u7F16\u8F91"),
      width: "600px",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form,
      "label-position": "right",
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Logo"
    }
  }, [_c("wlc-upload-image", {
    attrs: {
      url: _vm.form.logo
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "logo", $event);
      }
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "名称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "链接"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.link,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "link", $$v);
      },
      expression: "form.link"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };